/**
 * Specifies the gauge constant value
 */
/**
 * Sets and gets loaded event name in the circular gauge component.
 *  @private
 */
export var loaded = 'loaded';
/**
 * Sets and gets load event name in the circular gauge component.
 * @private
 */
export var load = 'load';
/**
 * Sets and gets animation complete event name in the circular gauge component.
 * @private
 */
export var animationComplete = 'animationComplete';
/**
 * Sets and gets axis label render event name in the circular gauge component.
 * @private
 */
export var axisLabelRender = 'axisLabelRender';
/**
 * Sets and gets radius calculate event name in the circular gauge component.
 *  @private
 */
export var radiusCalculate = 'radiusCalculate';
/**
 * Sets and gets tooltip render event name in the circular gauge component.
 * @private
 */
export var tooltipRender = 'tooltipRender';
/**
 * Sets and gets annotation render event name in the circular gauge component.
 * @private
 */
export var annotationRender = 'annotationRender';
/**
 * Sets and gets gauge mouse move event name in the circular gauge component.
 * @private
 */
export var gaugeMouseMove = 'gaugeMouseMove';
/**
 * Sets and gets gauge mouse leave event name in the circular gauge component.
 * @private
 */
export var gaugeMouseLeave = 'gaugeMouseLeave';
/**
 * Sets and gets gauge mouse down event name in the circular gauge component.
 * @private
 */
export var gaugeMouseDown = 'gaugeMouseDown';
/**
 * Sets and gets gauge mouse up event name in circular gauge component.
 * @private
 */
export var gaugeMouseUp = 'gaugeMouseUp';
/**
 * Sets and gets drag start event name in the circular gauge component.
 * @private
 */
export var dragStart = 'dragStart';
/**
 * Sets and gets drag move event name in the circular gauge component.
 * @private
 */
export var dragMove = 'dragMove';
/**
 * Sets and gets drag end event name in the circular gauge component.
 * @private
 */
export var dragEnd = 'dragEnd';
/**
 * Sets and gets resize event name in the circular gauge component.
 * @private
 */
export var resized = 'resized';
/**
 * Sets and gets before print event name in the circular gauge component.
 * @private
 */
export var beforePrint = 'beforePrint';
/**
 * Sets and gets pointer start event name in the circular gauge component.
 * @private
 */
export var pointerStart = 'pointerStart';
/**
 * Sets and gets pointer move event name in the circular gauge component.
 * @private
 */
export var pointerMove = 'pointerMove';
/**
 * Sets and gets pointer end event name in the circular gauge component.
 * @private
 */
export var pointerEnd = 'pointerEnd';
/**
 * Sets and gets range start event name in the circular gauge component.
 * @private
 */
export var rangeStart = 'rangeStart';
/**
 * Sets and gets range move event name in the circular gauge component.
 * @private
 */
export var rangeMove = 'rangeMove';
/**
 * Sets and gets range end event name in the circular gauge component.
 * @private
 */
export var rangeEnd = 'rangeEnd';
